<template lang="pug">
    div.thread-input-box.ml-sm-5.mx-2.mx-sm-4.mb-5(:class="{'has-text': message.length > 0 || ishover}" @mouseleave="ishover = false" @mouseover="ishover = true" @dragover.prevent @drop.prevent="handleThreadDrop")
        div.d-flex.flex-column.mt-1.pb-3.bottom-hr-line(v-if="openInstruction")
            div.pl-6.pt-2.pb-1(style='font-size:14px;') {{ $t("AGENT.INSTRUCTION") }}
            div.px-6
                textarea.input-field-upper.custom-height.h5-en-regular.ma-0.pa-2.custom-text-field.v-input__control.auto-textarea-boder(v-model="general_instructions" rows="3" style="resize:none; height: 85px;" readonly)
        div.d-flex.flex-column(v-if="openFileAttachement")
            div.px-6.pt-3.pb-1.d-flex(style='font-size:14px;') {{$t('AGENT_FILE_ATTACHMENT.ATTACHMENT')}}
            div.pt-1.px-6.pb-4.bottom-hr-line
                multipleFile(
                    :uploadBtnText="'Save'"
                    :progressBtnText="'Saving...'"
                    :uploadedFiles="files"
                    :isUploading="isUploading"
                    :isVisable="isVisable"
                    :schedule_access="true"
                    :accept="acceptFileTypes"
                    @addAttachmentData="addAttachmentData"
                    @showErrorDialog="showErrorDialog"
                )
        multipleFileThumbnail(
            ref="multipleFileRef"
            :showDropArea="false"
            :uploadBtnText="'Save'"
            :progressBtnText="'Saving...'"
            :uploadedFiles="followUpInitFiles"
            :isUploading="isUploading"
            :schedule_access="true"
            :accept="acceptFileTypes"
            @addAttachmentData="addAttachmentData"
            @showErrorDialog="showErrorDialog"
        )
        div.textarea-field
            textarea.input-field-upper.custom-height.h5-en-regular.ma-0.d-flex.align-end.custom-text-field.v-input__control(v-model="message" placeholder="Ask follow up" rows="2" ref="autoTextarea" :readonly="generating" @input="autoTextareaGrow" @keydown.enter.exact.prevent="queryQuestion" style="resize:none;")
        div.pt-1.px-4.d-flex.top-hr-line.align-center(style="border-bottom-width: 0px;")
            v-menu(offset-y top persistent)
                template(v-slot:activator="{ on, attrs }")
                    v-btn.mt-1.mb-1(class="kw-box d-flex justify-start align-center custom-btn" color="transparent" icon v-bind="attrs" v-on="on")
                        v-avatar(class="kw-button avatar-effect" icon size="24")
                            v-img(contain height="21.5px" src="@/assets/images/knowledge_select.svg" width="21px")
                        v-img(class="kw-button-tri" contain height="" src="@/assets/images/Triangle_Down.svg" style="height: 5px; width: 10px;")
                KnowledgeList(:knowledge-list="knowledgeList" :knowledge-list-private ="knowledgeListPrivate" :all-knowledge-color="allKnowledgeColor" :selected-knowledge-libs="selectedKnowledgeLibs" :canSearchWeb="use_web_search" :canUseKB="use_knowledge_lib"
                :folderTreeOptions="folderTreeOptions"
                @returnselectedKnowledge="getselectedKnowledgeList"
                @usewebsetting="data => changeFollowWebSearchSetting(data)" @useknowledgesetting="data => changeFollowUseKnowledgeSetting(data)")
            //- textarea.input-field-upper.custom-height.h5-en-regular.ma-0.pt-2.d-flex.align-end.custom-text-field.v-input__control(v-model="message" placeholder="Ask follow up" rows="1" ref="autoTextarea" @input="autoTextareaGrow" @keydown.enter.exact.prevent="queryQuestion" style="resize:none;")
            v-btn.mr-2(icon :disabled="(general_instructions == '' || general_instructions == null)" @click="handleOpenInstruction" :style="{backgroundColor: openInstruction ? '#D6F7FF' : 'transparent'}")
                v-img(contain height="21.5px" src="@/assets/images/instruction-icon.svg" width="21px" :class="{'disabled-img': (general_instructions == '' || general_instructions == null) || ''}")
            v-btn.mr-2(icon @click="$refs.multipleFileRef.selectFiles()" style="background: transparent")
                v-img(contain height="21.5px" src="@/assets/images/attachment_file.svg" width="21px")
            v-spacer
            v-btn.mt-0(v-if="!showStop" :disabled="!hasText || (hasText && generating) || isLicenseBlocking" class="send-button d-flex justify-end align-center" icon @click="queryQuestion")
                v-img(:src="sendButtonIcon" contain height="32" width="32")
            v-btn.mt-0(v-else class="send-button d-flex justify-end align-center" icon width="36" height="36" @click="stopCompletion")
                v-img(:src="require('@/assets/images/stop.svg')" contain height="20" width="20")
</template>

<script>
import Vue from 'vue';
import KnowledgeList from "./KnowledgeList.vue";
import multipleFile from "../Common/multipleFile.vue";
import multipleFileThumbnail from "../Common/multipleFileThumbnail.vue";

export default Vue.extend({
    props: {
        knowledgeList: {
            type: Array,
            required:true,
        },
        knowledgeListPrivate: {
            type: Array,
            required: true
        },
        selectedKnowledgeLibs: {
            type:Array,
            required: true
        },
        generating: {
            type: Boolean,
            required:true,
        },
        inputShowStop: {
            type: Boolean,
            required:true,
        },
        allKnowledgeColor:{
            type: Array,
            required:true
        },
        stepType:{
            type: String,
            required: true
        },
        checkAgent:{
            type: String,
            required: true
        },
        streamingId:{
            type: Object,
            required: true
        },
        currentThread:{
            type: Object,
            required: true
        },
        searchWebEnabled:{
            type: Boolean,
            default: () => false
        },
        knowledgeEnabled:{
            type: Boolean,
            default: () => true
        },
        folderTreeOptions:{
            type:Array,
            required: true
        }
    },
    components: {
        KnowledgeList,
        multipleFile,
        multipleFileThumbnail
    },
    mounted(){
        this.autoTextareaGrow();
    },
    async created(){
        this.use_web_search = this.searchWebEnabled;
        this.use_knowledge_lib = this.knowledgeEnabled;
    },
    data() {
        return{
            currentDisplayType: '',
            showStop: false,
            currentStepType: '',
            message: "",
            inputRows:1,
            sendIconA: require("@/assets/images/send.svg"), // A 圖片 (有文字時)
            sendIconB: require("@/assets/images/send_no_tex.svg"), // B 圖片 (無文字時)
            ishover: false,
            KnowledgeListData: this.selectedKnowledgeLibs, // 從component KnowledgeList 拿回資料放這裡
            general_instructions: "",
            openInstruction: false,
            openFileAttachement: false,
            files: [],
            followUpInitFiles: [],
            followUpNewFiles: [],
            isUploading: false,
            acceptFileTypes: '.pdf,.docx,.pptx,.jpg,.jpeg,.png',
            isVisable: false,
            isStopped: false,
            use_web_search: false,
            use_knowledge_lib: true,
        }
    },
    methods: {
        async stopCompletion(){
            this.$emit('stopGenerate');
        },
        autoTextareaGrow(){
            let el = this.$refs.autoTextarea;
            if (!el) return;
            el.style.height = 'auto';
            let maxHeight = 120;
            if(el.scrollHeight > maxHeight){
                el.style.height = maxHeight + 'px';
                el.style.overflowerY = 'auto';
            }else{
                el.style.height = el.scrollHeight + 'px';
                el.style.overflowerY = 'hidden';
            }
        },
        async queryQuestion(){
            if (this.generating) {
                return;
            }
            // 送出按鈕與 Enter 鍵都走這裡，擋在這一處兩種操作都擋得住——
            // 只停用按鈕擋不住 Enter。擋下時不清空 message，輸入內容保留。
            // 是否阻擋由 store 統一判斷（含送出前重新查詢一次），元件不自己比對狀態碼。
            if (await this.$store.dispatch('refreshLicenseBlocking')) {
                return;
            }
            if (this.hasText) {
                let data = {
                    "question_title": this.message,
                    "knowledges": this.KnowledgeListData,
                    "general_instructions": this.general_instructions,
                    "attach_document": [...(this.files || []), ...this.followUpNewFiles],
                    "use_web_search": this.use_web_search,
                    "use_knowledge_lib": this.use_knowledge_lib,
                }
                this.$emit("queryQuestion", data);
                this.message = ""; // 清空輸入框
                this.followUpNewFiles = [];
                if (this.$refs.multipleFileRef) this.$refs.multipleFileRef.clearFiles();
            }
        },
        getselectedKnowledgeList(data){
            this.KnowledgeListData = data;
        },
        addAttachmentData(data){
            this.followUpNewFiles = data;
        },
        async handleThreadDrop(event) {
            const dropped = (event.dataTransfer && event.dataTransfer.files) || [];
            if (!dropped.length || !this.$refs.multipleFileRef) return;
            const acceptList = this.acceptFileTypes.split(',').map(ext => ext.trim().toLowerCase());
            for (let i = 0; i < dropped.length; i++) {
                const file = dropped[i];
                const ext = '.' + file.name.toLowerCase().split('.').pop();
                if (acceptList.includes(ext)) {
                    await this.$refs.multipleFileRef.addFileFromPaste(file);
                }
            }
        },
        showErrorDialog(message){
            this.$emit("showErrorDialog", message);
        },
        handleOpenInstruction(){
            this.openInstruction = !this.openInstruction;
            this.openFileAttachement = false;
        },
        handleOpenFileAttachement(){
            this.openFileAttachement = !this.openFileAttachement;
            this.openInstruction = false;
        },
        changeFollowWebSearchSetting(data){
            this.use_web_search = data;
        },
        changeFollowUseKnowledgeSetting(data){
            this.use_knowledge_lib = data;
        },
    },
    computed: {
        hasText() {
            return this.message.trim().length > 0;
        },
        // 授權停止服務或無效時，送出按鈕無條件呈現停用外觀（有沒有文字都一樣）。
        // 這只是給使用者看的提示，真正擋住送出的是 queryQuestion() 的前置檢查。
        isLicenseBlocking() {
            return this.$store.getters.isLicenseBlocking;
        },
        sendButtonIcon() {
            return (this.hasText && !this.generating) ? this.sendIconA : this.sendIconB;
        },
        updateStreamingId(){
            return this.streamingId;
        }
    },
    watch: {
        message(){
            this.$nextTick(this.autoTextareaGrow);
        },
        selectedKnowledgeLibs:{
            immediate: true,
            handler(newVal){
                this.KnowledgeListData =  [...newVal];
            }
        },
        searchWebEnabled:{
            immediate: true,
            handler(newVal){
                this.use_web_search = newVal;
            } 
        },
        knowledgeEnabled:{
            immediate: true,
            handler(newVal){
                this.use_knowledge_lib = newVal;
            } 
        },
        currentThread:{
            immediate: true,
            handler(newVal){
                this.general_instructions = newVal['general_instructions'],
                this.files = newVal['attach_document']
                this.openInstruction = false;
            }
        },
        updateStreamingId:{
            handler(newVal){
                this.streamingId = newVal;
            }
        },
        inputShowStop: {
            immediate: true,
            handler(newVal) {
                this.showStop = newVal;
            }
        },
        stepType(newVal) {
            this.currentStepType = newVal;
        },
        checkAgent(newVal) {
            this.currentDisplayType = newVal;
        },
    }
})
</script>

<style lang="scss" scoped>
@import "@/style/portal/typography.scss";
@import "@/style/portal/component.scss";

/* 調整 v-input__control 的高度 */
.custom-btn:active .avatar-effect,
.custom-btn:focus .avatar-effect {
  background-color: rgba(0, 0, 0, 0.2); /* 點擊時的灰色背景 */
  border-radius: 50%; /* 確保背景是圓形的 */
  transition: background-color 0.2s ease-in-out;
}

.v-input__control .v-input__underlined {
  transition: none !important; /* 禁用動畫 */
}

.v-menu__content {
  box-shadow: 0px 0px 8px #9999994D;
}

.disabled-img {
  filter: grayscale(100%);
  opacity: 0.5;
}

/* 生成中輸入框為 readonly（擋住打字用），外觀維持跟可輸入時一模一樣，
   蓋掉 _inputBox.scss 對 textarea:read-only 的灰底灰字 */
.textarea-field textarea[readonly] {
  background-color: transparent;
  color: inherit;
}

</style>